<div class="container">
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      {{ 'energy.loadOnTree.legend' | translate }}
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 load-ON-view-legend">
      <div class="pull-left label label-machine-ON margin-7">
        {{ 'energy.loadOnTree.onStatus' | translate }}
      </div>
      <div class="pull-left label label-machine-OFF margin-7">
        {{ 'energy.loadOnTree.offStatus' | translate }}
      </div>
      <div class="pull-left label label-data-NA">
        {{ 'energy.loadOnTree.noData' | translate }}
      </div>
      <label></label>
      <label></label>
      <label></label>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <p-treeChart
        [value]="loadONTreeData"
        selectionMode="single"
        [(selection)]="selectedNode"
        (onNodeSelect)="onNodeSelect($event)"
        (onNodetoggle)="onNodetoggle($event)"
        styleClass="company"
      >
        <ng-template let-node pTemplate="person">
          <label class="fix-node" [ngClass]="getNodeClass(node.data)">{{
            node.label
          }}</label>
        </ng-template>
      </p-treeChart>
    </div>
  </div>
  <div class="row" ng-if="loadOnTreeLastF5Timestamp != undefined">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-note pull-bottom">
      {{ 'energy.loadOnTree.lastUpdate' | translate
      }}{{ loadOnTreeLastF5Timestamp | date: 'dd MMMM yyyy HH:mm:ss' }}
    </div>
  </div>
</div>
